module.exports = __webpack_public_path__ + "img/п.1.9d1ed461.png";